import { Injectable } from '@angular/core';
import { serverToFrontTranslation } from 'projects/common/src/lib/services/supabase.service';
import { finalize, map, shareReplay, switchMap, take } from 'rxjs/operators';
import { BusinessService } from './business.service';
import { SupabaseService } from './supabase.service';
import { UsersService } from './users.service';
import { combineLatest, Observable, of } from 'rxjs';

export interface NuveiInfo {
    showNuveiBanner: boolean;
    showCourseBanner: boolean;
    applicationStatus: null | 'created' | 'pending' | 'rejected' | 'approved' | 'missing_data' | 'sent_missing_data_to_nuvei';
    bankAccountNumber: null | string;
    missingDataList: null | string[];
}

@Injectable({
    providedIn: 'root'
})
export class OnboardingService {

    onboardingData$ = combineLatest([this.businessService.selectedBusiness$, this.usersSerivce.currentUser$]).pipe(
        switchMap(([business, user]) => {
            if (!business || (user.role !== 'owner' && !user.permissions.includes('access_credit_card')))
                return of(null);
            return this.supabaseService.rpc<NuveiInfo>({
                cName: 'onboarding_data',
                fn: 'get_nuvei_info',
                schema: business.businessId,
                tables: ['nuvei']
            });
        }),
        shareReplay({ bufferSize: 1, refCount: true })
    );

    constructor(
        private businessService: BusinessService,
        private supabaseService: SupabaseService,
        private usersSerivce: UsersService
    ) {}

    async dontShowBannerAgain(...which: ('nuvei' | 'course')[]) {
        const business = (await this.businessService.selectedBusiness$.pipe(take(1)).toPromise())!;
        if(which.length === 0)
            which = ['nuvei', 'course'];
        const data = which.reduce((acc, curr) => {
            acc[`show_${curr}_banner`] = false;
            return acc;
        }, {} as any);
        await this.supabaseService.supabase
            .schema(business.businessId)
            .from('nuvei')
            .update(data)
            .eq('id', 1);
    }
}
